import { render, staticRenderFns } from "./FamilyInfo.vue?vue&type=template&id=03730d9c&"
import script from "./FamilyInfo.vue?vue&type=script&lang=js&"
export * from "./FamilyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports